import React, { Component } from 'react';
import './CompanyCard.css';
// import RawActions from './Actions/RawActions';
// import StarredActions from './Actions/StarredActions';
// import LeadManager from '../data/leads';
// import Utility from '../data/utility';
// import SegmentedActions from './Actions/SegmentedActions';
// import CountryFlags from 'country-flag-emoji-json/json/flag-emojis-by-code';

class CompanyCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      details: this.props.lead
    };
  }

  componentDidMount() {
    // LeadManager.getLeadMetaForId(this.props.lead.id).then(data => {
    //   this.setState({
    //     details: data.meta
    //   });
    // });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.lead.id !== this.props.lead.id) {
      console.log('PROPS UPDATED', prevProps, this.props);
      // LeadManager.getLeadMetaForId(this.props.lead.id).then(data => {
      //   this.setState({
      //     details: data.meta
      //   });
      // });
    }
  }

  openImage = image => {
    window.open(image);
  };

  renderImages = () => {
    if (this.state && this.state.details && this.state.details.imgList) {
      return this.state.details.imgList.map((image, i) => {
        let src = image.src.replace('products', 'products_200');
        return (
          <div
            key={i}
            onClick={() => this.openImage(image.src)}
            className="CompanyProductImage"
            style={{ cursor: 'zoom-in', backgroundImage: `url(${src})` }}
          />
        );
      });
    }
  };

  render() {
    let { details } = this.state;
    let { lead, i } = this.props;
    if (details && lead.id === '-LmmHklMQC_ngwJHa-Hu') {
      console.log('ANSWER XXX', lead, details);
    }

    var whatsAppMessage = 'Hello';

    return details ? (
      <div className="CompanyCard">
        <div className="CompanyCardContainer">
          <a
            href={`http://localhost:8000?companyId=${lead.id}`}
            target="_blank"
          >
            {lead.id}
          </a>

          <div className="Names">
            <div className="CompanyName">{details.name} </div>
            <div className="UserName">
              {' '}
              {details.ownerName} from{' '}
              {details.location && details.location.city},{' '}
              {details.location && details.location.country}{' '}
            </div>
          </div>

          <div className="CompanyPictures">{this.renderImages()}</div>

          {/*<div className="Flag">*/}
          {/*{details.location && CountryFlags[details.location.country_code].emoji}*/}
          {/*</div>*/}

          <div className="CompanyMeta">
            {details.totalCatalogues ? (
              <div>{details.totalCatalogues} catalogues</div>
            ) : null}
            {details.totalProducts ? (
              <div>{details.totalProducts} products</div>
            ) : null}
            {details.totalVisitor ? (
              <div>{details.totalVisitor} visitors</div>
            ) : null}
            {details.totalInquiries ? (
              <div>{details.totalInquiries} inquiries</div>
            ) : null}
            {details.email ? <div>{details.email}</div> : null}
            {lead.product_category ? <div>{lead.product_category}</div> : null}
            {lead.business_category ? (
              <div>{lead.business_category}</div>
            ) : null}
            {lead.usecase_category ? <div>{lead.usecase_category}</div> : null}
            {lead.hotness ? <div>Hot : {lead.hotness}</div> : null}
          </div>

          <div className="LeadActions">
            {details.contact && (
              <a
                target={`_blank`}
                href={`https://api.whatsapp.com/send?phone=${details.contact.slice(
                  1
                )}&text=${whatsAppMessage}`}
              >
                WhatsApp
              </a>
            )}
          </div>
        </div>
      </div>
    ) : null;
  }
}

export default CompanyCard;



// WEBPACK FOOTER //
// ./src/pages/UsageDashboard/Components/CompanyCard.js